import { useMemo, useState } from 'react';
import { productErrorMessageKey } from '../utils/productErrors';

export function useProductMutationFeedback() {
  const [errorKey, setErrorKey] = useState<string | null>(null);

  const callbacks = useMemo(
    () => ({
      onSuccess: () => setErrorKey(null),
      onError: (error: unknown) => setErrorKey(productErrorMessageKey(error)),
    }),
    [],
  );

  return { errorKey, callbacks };
}
